import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SeoHead from "@/components/SeoHead";
import { ArrowLeft } from "lucide-react";
import PrivacyPageContent from "./legal/PrivacyPageContent";
import { useLegalScrollReached } from "./legal/useLegalScrollReached";

export default function PrivacyPage() {
  const { t } = useTranslation();
  useLegalScrollReached("privacy");

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SeoHead
        path="privacy"
        title={t("footer.privacy", "Privacy Policy") + " - BamaBang"}
        description="BamaBang privacy policy. Learn how we collect, use, and protect your personal data on our parent-led matchmaking platform."
      />
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link
            to="/"
            className="flex items-center text-gray-600 hover:text-pink-600 transition"
          >
            <ArrowLeft className="w-5 h-5 mr-1" />
            <span className="text-sm font-medium hidden sm:inline">Back</span>
          </Link>
          <span className="text-sm text-gray-400">|</span>
          <span className="text-sm font-bold text-gray-700">BamaBang</span>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 max-w-3xl mx-auto p-8 pb-32">
        <PrivacyPageContent />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-10 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm">© 2026 bamabang.net. All rights reserved.</p>
          <div className="mt-3 flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/terms" className="hover:text-white transition">
              {t("footer.terms")}
            </Link>
            <Link
              to="/refund"
              className="hover:text-white transition font-semibold text-pink-400 hover:text-pink-300"
            >
              {t("footer.refund", "Refund & Cancellation Policy")}
            </Link>
            <Link to="/support" className="hover:text-white transition">
              {t("support.contact_title", "Contact Us")}
            </Link>
          </div>
          <p className="mt-4 text-xs">
            Contact Us: bamabang.info@gmail.com
          </p>
        </div>
      </footer>
    </div>
  );
}
